import React from 'react'
import { FormattedMessage } from 'react-intl'

const FrequencyForm = ({ name }) => (
  <div>
    <h6>Fréquence</h6>
    <label htmlFor={`${name}-morning`}>
      <FormattedMessage id="morning" />
    </label>
    <input type="checkbox" id={`${name}-morning`} name={`${name}-morning`} />
    <label htmlFor={`${name}-midday`}>
      <FormattedMessage id="midday" />
    </label>
    <input type="checkbox" id={`${name}-midday`} name={`${name}-midday`} />
    <label htmlFor={`${name}-evening`}>
      <FormattedMessage id="evening" />
    </label>
    <input type="checkbox" id={`${name}-evening`} name={`${name}-evening`} />
    <br />
    <label htmlFor={`${name}-frequency`}>
      <FormattedMessage id="daysPerWeek" />
    </label>
    <select name={`${name}-frequency`}>
      <option value="0">0</option>
      <option value="1">1</option>
      <option value="2">2</option>
      <option value="3">3</option>
      <option value="4">4</option>
      <option value="5">5</option>
      <option value="6">6</option>
      <option value="7">7</option>
    </select>/7
    <br />
    <label htmlFor={`${name}-duration`}>
      <FormattedMessage id="duration" />
    </label>
    <input type="number" id={`${name}-duration`} name={`${name}-duration`} />
    <select name={`${name}-duration-unit`}>
      <FormattedMessage id="days">
        {label => <option value="d">{label}</option>}
      </FormattedMessage>
      <FormattedMessage id="months">
        {label => <option value="mo">{label}</option>}
      </FormattedMessage>
      <FormattedMessage id="years">
        {label => <option value="a">{label}</option>}
      </FormattedMessage>
    </select>
    <br />
    <label htmlFor={`${name}-timeDelay`}>
      <FormattedMessage id="when" />
    </label>
    <input type="number" id={`${name}-timeDelay`} name={`${name}-timeDelay`} />
    <select name={`${name}-timeDelay-unit`}>
      <FormattedMessage id="minutes">
        {label => <option value="minutes">{label}</option>}
      </FormattedMessage>
      <FormattedMessage id="hours">
        {label => <option value="hours">{label}</option>}
      </FormattedMessage>
    </select>
    <select name={`${name}-timeDelay-comment`}>
      <FormattedMessage id="beforeMeals">
        {label => <option value="AC">{label}</option>}
      </FormattedMessage>
      <FormattedMessage id="duringMeals">
        {label => <option value="C">{label}</option>}
      </FormattedMessage>
      <FormattedMessage id="afterMeals">
        {label => <option value="PC">{label}</option>}
      </FormattedMessage>
    </select>
  </div>
)

export default FrequencyForm



// WEBPACK FOOTER //
// ./src/Goal/components/FrequencyForm.js